var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_12544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.75 0H1.25C0.918479 0 0.600537 0.134623 0.366117 0.374252C0.131696 0.613882 0 0.93889 0 1.27778L0 21.7222C0 22.0611 0.131696 22.3861 0.366117 22.6257C0.600537 22.8654 0.918479 23 1.25 23H28.75C29.0815 23 29.3995 22.8654 29.6339 22.6257C29.8683 22.3861 30 22.0611 30 21.7222V1.27778C30 0.93889 29.8683 0.613882 29.6339 0.374252C29.3995 0.134623 29.0815 0 28.75 0Z",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 1.27778C30 0.93889 29.8683 0.613882 29.6339 0.374252C29.3995 0.134623 29.0815 0 28.75 0H25.5244L17.5 6.30967V0H12.5V6.30967L4.47563 0H1.25C0.918479 0 0.600537 0.134623 0.366117 0.374252C0.131696 0.613882 0 0.93889 0 1.27778L0 2.92994L7.64937 8.94444H0V14.0556H7.64937L0 20.0707V21.7222C0 22.0611 0.131696 22.3861 0.366117 22.6257C0.600537 22.8654 0.918479 23 1.25 23H4.47563L12.5 16.6903V23H17.5V16.6903L25.5244 23H28.75C29.0815 23 29.3995 22.8654 29.6339 22.6257C29.8683 22.3861 30 22.0611 30 21.7222V20.0707L22.3506 14.0556H30V8.94444H22.3506L30 2.92994V1.27778Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 10.2222H16.25V0H13.75V10.2222H0V12.7778H13.75V23H16.25V12.7778H30V10.2222Z",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.8787L0.98877 22.9713C1.07466 22.99 1.1622 22.9997 1.25002 23.0001H2.74127L12.5 15.2919V13.8787Z",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.12142L29.0112 0.02875C28.9254 0.0100755 28.8378 0.000441863 28.75 0H27.2587L17.5 7.70883V9.12142Z",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2537 8.94452L0.384375 0.359131C0.262898 0.477769 0.166208 0.620347 0.100143 0.778252C0.0340787 0.936157 1.17772e-05 1.10611 0 1.27785L0 1.46952L9.465 8.94452H11.2537Z",
    fill: "#D10D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7463 14.0557L29.6157 22.6411C29.7372 22.5224 29.8339 22.3798 29.8999 22.2219C29.966 22.064 30.0001 21.8941 30.0001 21.7223V21.5307L20.5351 14.0557H18.7463Z",
    fill: "#D10D24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_12544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 23,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.90cf7c2ac77f45ab64712a5796132a5d.svg";
export { ForwardRef as ReactComponent };